export default __webpack_public_path__ + "static/media/low_quantity_sku.3bf1509b.svg";